"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.detectTasks.name': 'Detección de Tareas',
    'tools.detectTasks.description': 'Detecta y extrae automáticamente información de tareas de los mensajes del usuario',
};
